import React from 'react'
import Dashnav from '../Components/Dashnav'
import AdmissionTopNotice from '../Components/AdmissionTopNotice'
import Leftmenu from '../Components/Leftmenu'
import NorthstarHubComp from './NorthstarHubComp'

function StudentsPathways() {
  return (
    <div>
      <div className='mainContainer'>
        <Leftmenu />
        <div className='theMainContainer'>
          <Dashnav />
          <AdmissionTopNotice />
          <NorthstarHubComp />
        </div>
      </div>
    </div>
  )
}

export default StudentsPathways
